export const SITE_DEFAULT_TITLE = 'Untitled';
export const SITE_TITLE_LIMIT = 50;

export function normalizeSiteTitle(title: string): string {
    return title
        .replace(/(\r\n|\r|\n)/g, ' ')
        .trim()
        .slice(0, SITE_TITLE_LIMIT)
        .trim();
}

export function getSiteTitle(title?: string | undefined | null): string {
    return title || SITE_DEFAULT_TITLE;
}
